module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "flex bg-white new-shadow-theme br3 custom-padding responsive-box"
  }, [_c('div', {
    staticClass: "flex flex-column w-100 responsive-plan"
  }, [_c('img', {
    staticClass: "image-bot",
    attrs: {
      "src": "/static/upsell/upsellConfirm.png",
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center mt4"
  }, [_c('ak-button', {
    staticClass: "button-responsive",
    attrs: {
      "newPrimary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.finishUpsell(true)
      }
    }
  }, [_vm._v("\n        Continue\n      ")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt4 flex flex-column justify-center items-center cera-round-pro-medium"
  }, [_c('div', {
    staticClass: "w-50-l w-100 tc ph4 ph0-l"
  }, [_c('div', {
    staticClass: "f4 mb2"
  }, [_vm._v("Add-ons Successfully Added!")]), _vm._v(" "), _c('div', {
    staticClass: "gray-text inter f6"
  }, [_vm._v("Congrats! The add-on plan has been successfully added to your account. You will soon receive an email with instructions on setting up your coverage")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca7e5adc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/upsell/ConfirmUpsell.vue
// module id = 1018
// module chunks = 0